import React from 'react'
import PublicDashboardPreview from './PublicDashboardPreview'
import PublicBuyTicketsPreview from './PublicBuyTicketsPreview'

class PublicPreviewModal extends React.Component {
    state = {
        activeTab: 'landing'
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            this.setState({ activeTab: 'landing' })
        }
    }

    render() {
        if (!this.props.open) return null
        const { client, event, onClose } = this.props
        const tabs = [
            { key: 'landing', label: 'Landing page' },
            { key: 'buy', label: 'Buy Tickets' }
        ]

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm">
                <div className="relative max-h-[92vh] w-full max-w-[1180px] overflow-auto rounded-[32px] border border-slate-200 bg-white p-4 shadow-2xl dark:border-slate-800 dark:bg-slate-950 sm:p-6">
                    <button
                        type="button"
                        className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-300 bg-white text-lg text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
                        onClick={onClose}
                    >
                        ×
                    </button>
                    <div className="mb-5 flex items-center justify-center">
                        <div className="inline-flex rounded-full border border-slate-200 bg-slate-100 p-1 dark:border-slate-700 dark:bg-slate-900">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.key}
                                    type="button"
                                    onClick={() => this.setState({ activeTab: tab.key })}
                                    className={'rounded-full px-4 py-2 text-sm font-semibold transition ' + (this.state.activeTab === tab.key
                                        ? 'bg-sky-500 text-slate-950'
                                        : 'text-slate-600 hover:bg-white dark:text-slate-300 dark:hover:bg-slate-800')}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="flex justify-center overflow-hidden">
                        {this.state.activeTab === 'landing'
                            ? <PublicDashboardPreview client={client} event={event} scaleClassName="scale-[0.9]" showChrome={false} />
                            : <PublicBuyTicketsPreview client={client} event={event} scaleClassName="scale-[0.9]" />}
                    </div>
                </div>
            </div>
        )
    }
}

export default PublicPreviewModal
